"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = OrgChart;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const react_native_svg_1 = __importStar(require("react-native-svg"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_i18next_1 = require("react-i18next");
const UserContext_1 = require("../contexts/UserContext");
const ThemeContext_1 = require("../ThemeContext");
const Theme_1 = require("../Theme");
const OrgChart_1 = __importDefault(require("../api/OrgChart"));
const Loading_1 = __importDefault(require("../components/Loading"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
// Recursive functions are named with "r_" at the beginning.
const r_measure = (node, depth) => {
    let measure = { depth };
    if (!node.employees || node.employees.length == 0) {
        measure.width = 1;
        measure.height = 1;
    }
    else {
        measure.width = 0;
        measure.widest = 0;
        measure.tallest = 0;
        for (let e of node.employees) {
            let n = r_measure(e, depth + 1);
            measure.width += n.measure.width;
            measure.widest = Math.max(measure.widest, n.measure.width);
            measure.tallest = Math.max(measure.tallest, n.measure.height);
        }
        measure.height = measure.tallest + Math.min(1, depth);
    }
    node.measure = measure;
    return node;
};
const ListViewNode = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const s = props.settings;
    const viewRef = react_1.default.useRef(null);
    const [viewSize, setViewSize] = react_1.default.useState({ width: 0, height: 0, set: false });
    react_1.default.useLayoutEffect(() => {
        if (viewSize.set)
            return;
        viewRef.current?.measure((x, y, w, h, px, py) => {
            setViewSize({ width: w, height: h, set: true });
        });
    }, []);
    const dataEmail = (props.data.email ?? '').trim();
    const dataPhone = ((props.data.phone ?? '') + (props.data.extension ? ' x' + props.data.extension : '')).trim();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: (react_native_1.Platform.OS == 'web' ? null : 1) }, children: [(props.data.measure.depth > 0) &&
                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsxs)(react_native_svg_1.default, { width: ((props.data.measure.depth - 1) * s.gap), height: viewSize.height + 2, viewBox: `0 0 ${((props.data.measure.depth - 1) * s.gap)} ${viewSize.height}`, 
                            // @ts-ignore
                            style: { flexShrink: 0, userSelect: 'none', marginBottom: -2 }, children: [(props.data.measure.depth > 1) &&
                                    [...Array(props.data.measure.depth - 1)].map((v, i) => (!props.last[i + 1] || i == props.last.length - 2) &&
                                        (0, jsx_runtime_1.jsx)(react_native_svg_1.Line, { stroke: THEME.CoolGray, strokeWidth: 2, x1: ((i + 1) * s.indent) + (i * (s.gap - s.indent)), y1: -2, x2: ((i + 1) * s.indent) + (i * (s.gap - s.indent)), y2: (props.last[props.data.measure.depth - 1] && (i == props.data.measure.depth - 2)) ? ((viewSize.height + 12 + 2) / 2) : (viewSize.height + 2) }, 'line-' + props.keyPrefix + '-' + i)), (0, jsx_runtime_1.jsx)(react_native_svg_1.Line, { stroke: THEME.CoolGray, strokeWidth: 2, x1: ((props.data.measure.depth - 1) * s.indent) + ((props.data.measure.depth - 2) * (s.gap - s.indent)), y1: (viewSize.height + 12) / 2, x2: ((props.data.measure.depth - 2) * s.indent) + (props.data.measure.depth * (s.gap - s.indent + 2)), y2: (viewSize.height + 12) / 2 })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { ref: viewRef, style: { paddingTop: 12 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                    backgroundColor: THEME.CardBackground,
                                    borderColor: THEME.Gray,
                                    borderWidth: 1,
                                    borderRadius: 2,
                                    flexDirection: 'row',
                                    overflow: 'hidden',
                                    marginRight: 12
                                }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                            backgroundColor: THEME.Gray + '33',
                                            paddingHorizontal: (size != 'sm' ? 20 : 12),
                                            paddingVertical: (size != 'sm' ? 12 : 8),
                                            flexDirection: 'column',
                                            gap: (size != 'sm' ? 4 : 2)
                                        }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 1, style: { fontSize: (size != 'sm' ? 14 : 12), color: THEME.Text, fontWeight: '500' }, children: props.data.displayName }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 1, style: { fontSize: (size != 'sm' ? 13 : 11), color: THEME.Text }, children: props.data.jobTitle })] }), ((props.settings.showEmail && !!dataEmail?.length) ||
                                        (props.settings.showPhone && !!dataPhone?.length)) &&
                                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                                paddingHorizontal: (size != 'sm' ? 20 : 12),
                                                paddingVertical: (size != 'sm' ? 12 : 8),
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                gap: (size != 'sm' ? 4 : 2),
                                            }, children: [(props.settings.showEmail && !!dataEmail?.length) &&
                                                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', gap: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                                    fontSize: (size != 'sm' ? 12 : 10),
                                                                    color: THEME.Text, fontWeight: '400', opacity: 0.5
                                                                }, children: "Email" }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                                    fontSize: (size != 'sm' ? 12 : 10),
                                                                    color: THEME.Text, flexShrink: 1
                                                                }, children: dataEmail })] }), (props.settings.showPhone && !!dataPhone?.length) &&
                                                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', gap: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                                    fontSize: (size != 'sm' ? 12 : 10),
                                                                    color: THEME.Text, fontWeight: '400', opacity: 0.5
                                                                }, children: "Phone" }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                                    fontSize: (size != 'sm' ? 12 : 10),
                                                                    color: THEME.Text, flexShrink: 1
                                                                }, children: dataPhone })] })] })] }) })] }), !!props.data?.employees &&
                (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.data?.employees?.map((item, index) => (0, jsx_runtime_1.jsx)(ListViewNode, { keyPrefix: props.keyPrefix + '-' + index, settings: props.settings, data: item, find: props.find, last: [
                            ...(props.last ?? []),
                            (index == props.data?.employees?.length - 1)
                        ] }, props.keyPrefix + '-' + index)) })] }));
};
const ListView = (props) => {
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const settings = {
        ...props.settings,
        indent: (size != 'sm' ? (20 + 4) : (12 + 4)),
        gap: (size != 'sm' ? ((20 * 2) + 4) : ((12 * 2) + 4))
    };
    const viewRef = react_1.default.useRef(null);
    const [viewSize, setViewSize] = react_1.default.useState({ width: 0, height: 0, set: false });
    const [data, setData] = react_1.default.useState(null);
    react_1.default.useLayoutEffect(() => {
        if (viewSize.set)
            return;
        viewRef.current?.measure((x, y, w, h, px, py) => {
            let vs = { width: w, height: h, set: true };
            setTimeout(() => setViewSize(vs), 1);
        });
    }, []);
    react_1.default.useEffect(() => {
        if (!props.data)
            return;
        setData(r_measure(props.data, 0));
    }, [props.data]);
    return (
    // @ts-ignore
    (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { style: {
            flex: 1,
            overflow: (react_native_1.Platform.OS == 'web' ? 'auto' : 'scroll'),
        }, children: (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { horizontal: true, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { ref: viewRef, style: {
                    borderColor: '#ddd',
                    borderWidth: 0,
                    borderRadius: 0,
                    flex: 1,
                    paddingHorizontal: (size != 'sm' ? 24 : 12),
                    paddingVertical: (size != 'sm' ? (24 - 6) : 6),
                    marginTop: (size != 'sm' ? 36 : 48),
                }, children: viewSize?.set &&
                    (0, jsx_runtime_1.jsx)(ListViewNode, { settings: settings, data: data }) }) }) }));
};
const ChartViewNode = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const s = props.settings;
    const dataEmail = (props.data.email ?? '').trim();
    const dataPhone = ((props.data.phone ?? '') + (props.data.extension ? ' x' + props.data.extension : '')).trim();
    const childFirst = props.data?.employees?.[0];
    const childLast = props.data?.employees?.slice(-1)?.[0];
    const centerFirst = (childFirst?.measure?.width / 2 * s.width) + ((childFirst?.measure?.width - 1) / 2 * s.gapX);
    const centerLast = (childLast?.measure?.width / 2 * s.width) + ((childLast?.measure?.width - 1) / 2 * s.gapX);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
            position: 'absolute',
            left: props.data.layout.translateX,
            top: props.data.layout.translateY
        }, children: [(props.data.measure.depth > 0 &&
                props.data.childCount > 0) &&
                (0, jsx_runtime_1.jsxs)(react_native_svg_1.default, { style: {
                        position: 'absolute',
                        left: ((props.data.layout.groupWidth / 2) - s.thickness),
                        top: s.height,
                        width: (s.thickness * 2),
                        height: (s.gapY / 2)
                    }, children: [(0, jsx_runtime_1.jsx)(react_native_svg_1.Defs, { children: (0, jsx_runtime_1.jsxs)(react_native_svg_1.LinearGradient, { id: "fill", x1: 0, y1: 0, x2: 0, y2: 1, children: [(0, jsx_runtime_1.jsx)(react_native_svg_1.Stop, { offset: 0.0, stopColor: THEME.CoolGray, stopOpacity: "1" }), (0, jsx_runtime_1.jsx)(react_native_svg_1.Stop, { offset: 1.0, stopColor: THEME.CoolGray, stopOpacity: "0" })] }) }), (0, jsx_runtime_1.jsx)(react_native_svg_1.Rect, { x: s.thickness - (s.thickness / 2), width: s.thickness, height: s.gapY / 2, fill: props.data?.employees?.length > 0 ? THEME.CoolGray : "url(#fill)" })] }), (props.data.measure.depth > 0) &&
                (() => {
                    let left = 0;
                    return props.data?.employees?.map((item, index) => {
                        let isFirst = index == 0;
                        let isLast = index == props.data?.employees?.length - 1;
                        let curved = (isFirst || isLast) && props.data?.employees?.length > 1;
                        let width = (curved ? (s.curve * 3) : s.thickness * 2);
                        let element = ((0, jsx_runtime_1.jsx)(react_native_svg_1.default, { style: {
                                position: 'absolute',
                                left: ((left + (item.measure.width / 2)) * (s.width + s.gapX)) - (s.gapX / 2) - (width / 2),
                                top: s.height,
                                width: width,
                                height: s.gapY
                            }, children: curved
                                &&
                                    (0, jsx_runtime_1.jsx)(react_native_svg_1.Path, { fill: "none", stroke: THEME.CoolGray, strokeWidth: s.thickness, transform: [{ translateX: (width / 2) }], d: `
                                            M 0, ${s.gapY}
                                            L 0, ${(s.gapY / 2) + s.curve}
                                            C 0, ${(s.gapY / 2) + s.curve} 0, ${s.gapY / 2} ${s.curve * (isFirst ? 1 : -1)}, ${s.gapY / 2}
                                            L ${s.curve * (isFirst ? 2 : -2)}, ${s.gapY / 2}
                                        ` })
                                ||
                                    (0, jsx_runtime_1.jsx)(react_native_svg_1.Rect, { fill: THEME.CoolGray, x: (width / 2) - (s.thickness / 2), y: s.gapY / 2, width: s.thickness, height: s.gapY / 2 }) }, 'line-' + props.data.id + '-' + item.id));
                        left += item.measure.width;
                        return element;
                    });
                })(), (props.data.measure.depth > 0 &&
                props.data.childShown > 0 &&
                props.data.childCount > props.data.childShown) &&
                (0, jsx_runtime_1.jsxs)(react_native_svg_1.default, { style: {
                        position: 'absolute',
                        left: ((props.data.layout.groupWidth / 2) - (s.width / 2) - (s.thickness / 2)),
                        top: s.height,
                        width: s.width,
                        height: s.gapY
                    }, children: [(0, jsx_runtime_1.jsx)(react_native_svg_1.Defs, { children: (0, jsx_runtime_1.jsxs)(react_native_svg_1.LinearGradient, { id: "z", x1: 0, y1: 0, x2: 1, y2: 0, children: [(0, jsx_runtime_1.jsx)(react_native_svg_1.Stop, { offset: 0, stopColor: THEME.CoolGray, stopOpacity: "0" }), (0, jsx_runtime_1.jsx)(react_native_svg_1.Stop, { offset: 0.5, stopColor: THEME.CoolGray, stopOpacity: "1" }), (0, jsx_runtime_1.jsx)(react_native_svg_1.Stop, { offset: 1, stopColor: THEME.CoolGray, stopOpacity: "0" })] }) }), (0, jsx_runtime_1.jsx)(react_native_svg_1.Rect, { y: (s.gapY / 2) - (s.thickness / 2), width: s.width, height: s.thickness, fill: "url(#z)" })] }), (props.data.measure.depth > 0 && props.data?.employees?.length > 1) &&
                (0, jsx_runtime_1.jsx)(react_native_svg_1.default, { viewBox: `0 0 ${s.thickness} ${s.gapY}`, preserveAspectRatio: "none", style: {
                        position: 'absolute',
                        left: centerFirst + (s.curve * 1.5) - 1,
                        top: s.height,
                        width: (props.data.layout.groupWidth - centerFirst - centerLast - (s.curve * 3) + 2),
                        height: s.gapY
                    }, children: (0, jsx_runtime_1.jsx)(react_native_svg_1.Path, { fill: "none", stroke: THEME.CoolGray, strokeWidth: s.thickness, d: `M 0, ${s.gapY / 2} L ${s.thickness}, ${s.gapY / 2} Z ` }) }), (() => {
                let left = 0;
                let top = 0;
                return props.data?.employees?.map((item) => {
                    let element = ((0, jsx_runtime_1.jsx)(ChartViewNode, { settings: props.settings, data: item, photos: props.photos, left: props.data.measure.depth > 0 ? left : 0, top: props.data.measure.depth == 0 ? top : 0, svgWidth: props.svgWidth, svgHeight: props.svgHeight, onExpand: props.onExpand }, 'node-' + item.id));
                    left += item.measure.width;
                    top += item.measure.height;
                    return element;
                });
            })(), (props.data.measure.depth > 0) &&
                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                        position: 'absolute',
                        left: props.data.layout.centering
                    }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                position: 'absolute',
                                width: s.width,
                                height: s.height,
                                borderRadius: 4,
                                borderWidth: 1,
                                borderColor: THEME.Gray,
                                backgroundColor: THEME.CardBackground,
                                overflow: 'hidden',
                                cursor: (props.data.childCount > 0 ? 'pointer' : null)
                            }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                        backgroundColor: THEME.Gray + "33",
                                        flexDirection: 'row', alignItems: 'center'
                                    }, children: [props.photos?.[props.data.id]
                                            &&
                                                (0, jsx_runtime_1.jsx)(react_native_1.Image, { style: {
                                                        width: s.photo,
                                                        height: s.photo,
                                                        margin: s.padding,
                                                        borderRadius: 4
                                                    }, source: { uri: `data:image/unknown;base64,${props.photos?.[props.data.id]}` } })
                                            ||
                                                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                                        width: s.photo,
                                                        height: s.photo,
                                                        margin: s.padding,
                                                        borderRadius: 4,
                                                        backgroundColor: THEME.Secondary,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.White, fontSize: 22 }, children: props.data.initials }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                                flex: 1, flexDirection: 'column', marginRight: s.padding,
                                                gap: (react_native_1.Platform.OS == 'web' ? (s.padding / 2) : (s.padding / 4)),
                                            }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 1, style: {
                                                        flexShrink: 1, color: THEME.Text, fontWeight: '500',
                                                        fontSize: (react_native_1.Platform.OS == 'web' ? 16 : 15)
                                                    }, children: props.data.displayName }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 1, style: {
                                                        flexShrink: 1, color: THEME.Text,
                                                        fontSize: (react_native_1.Platform.OS == 'web' ? 14 : 13)
                                                    }, children: props.data.jobTitle })] })] }), (props.settings.showEmail || props.settings.showPhone) &&
                                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                            flex: 1,
                                            paddingVertical: (s.padding / 2),
                                            paddingHorizontal: s.padding,
                                            flexDirection: 'column',
                                            justifyContent: 'space-evenly'
                                        }, children: [props.settings.showEmail &&
                                                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', gap: s.padding }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                                color: THEME.Text,
                                                                opacity: 0.6,
                                                                width: s.photo,
                                                                flexShrink: 0,
                                                                textAlign: 'center',
                                                                fontSize: (react_native_1.Platform.OS == 'web' ? 12 : 11)
                                                            }, children: "Email" }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 1, style: {
                                                                color: THEME.Text,
                                                                flexShrink: 1,
                                                                fontSize: (react_native_1.Platform.OS == 'web' ? 12 : 11),
                                                                opacity: dataEmail.length ? 1 : 0.4
                                                            }, children: dataEmail.length ? dataEmail : '\u2014' })] }), props.settings.showPhone &&
                                                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', gap: s.padding }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                                color: THEME.Text,
                                                                opacity: 0.6,
                                                                width: s.photo,
                                                                flexShrink: 0,
                                                                textAlign: 'center',
                                                                fontSize: (react_native_1.Platform.OS == 'web' ? 12 : 11)
                                                            }, children: "Phone" }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 1, style: {
                                                                color: THEME.Text,
                                                                flexShrink: 1,
                                                                fontSize: (react_native_1.Platform.OS == 'web' ? 12 : 11),
                                                                opacity: dataPhone.length ? 1 : 0.4
                                                            }, children: dataPhone.length ? dataPhone : '\u2014' })] })] })] }), props.data.childCount > 0 &&
                            (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                    position: 'absolute',
                                    top: s.height + (s.padding / 2),
                                    width: s.width - (s.padding / 2),
                                    flexDirection: 'row',
                                    justifyContent: 'flex-end',
                                    gap: (s.padding / 2),
                                    cursor: 'pointer'
                                }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: 12 }, children: props.data.childShown + ' of ' + props.data.childCount }), (0, jsx_runtime_1.jsx)(react_native_svg_1.default, { viewBox: "0 0 14 14", style: {
                                            width: 14, height: 14,
                                            marginTop: (react_native_1.Platform.OS == 'web' ? -3 : 0)
                                        }, children: (0, jsx_runtime_1.jsx)(react_native_svg_1.Path, { fill: THEME.Text, transform: [{ scale: 0.033 }], d: "M140.3 376.8c12.6 10.2 31.1 9.5 42.8-2.2l128-128c9.2-9.2 11.9-22.9 6.9-34.9S301.4 192 288.5 192l-256 0c-12.9 0-24.6 7.8-29.6 19.8S.7 237.5 9.9 246.6l128 128 2.4 2.2z" }) })] })] })] }));
};
const ChartView = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const settings = {
        ...props.settings,
        width: 250, // Single node width.
        height: 66, // Single node height.
        gapX: 20, // Horizontal gap between nodes.
        gapY: 80, // Vertical gap between nodes.
        photo: 48, // Dimensions of photos.
        padding: 8, // Padding within single node.
        curve: 12, // Size of connecting line curve.
        thickness: 2 // Connecting line thickness.
    };
    if ((settings.showEmail && !settings.showPhone) ||
        (settings.showPhone && !settings.showEmail)) {
        settings.width = 320;
        settings.height = settings.height + settings.padding + (react_native_1.Platform.OS == 'web' ? 20 : 26) + settings.padding;
    }
    if (settings.showEmail && settings.showPhone) {
        settings.width = 320;
        settings.height = settings.height + settings.padding + (react_native_1.Platform.OS == 'web' ? 38 : 44) + settings.padding;
    }
    const viewRef = react_1.default.useRef(null);
    const [viewSize, setViewSize] = react_1.default.useState({ width: 0, height: 0, set: false });
    const startX = react_1.default.useRef(0);
    const startY = react_1.default.useRef(0);
    const latestX = react_1.default.useRef(0);
    const latestY = react_1.default.useRef(0);
    const translateX = react_1.default.useRef(new react_native_1.Animated.Value(0)).current;
    const translateY = react_1.default.useRef(new react_native_1.Animated.Value(0)).current;
    const startScale = react_1.default.useRef(0);
    const latestScale = react_1.default.useRef(1);
    const scale = react_1.default.useRef(new react_native_1.Animated.Value(1)).current;
    const [data, setData] = react_1.default.useState(null);
    const [size, setSize] = react_1.default.useState({ width: 0, height: 0 });
    const [visible, setVisible] = react_1.default.useState([]);
    const [always, setAlways] = react_1.default.useState([]);
    const [standalone, setStandalone] = react_1.default.useState([]);
    // Filter nodes based on ID for expand and collapse.
    const r_filter = (node, include) => {
        let employees = [];
        let childShown = 0;
        let childCount = node.employees?.length ?? 0;
        if (childCount > 0) {
            for (let e of node.employees) {
                if (include.includes(e.id)) {
                    childShown += 1;
                    let n = r_filter(e, include);
                    if (n)
                        employees.push(n);
                }
            }
        }
        return { ...node, childCount, childShown, employees };
    };
    // Calculate layout positioning for render and handling presses.
    const r_layout = (node, s, prev) => {
        let layout = {
            translateX: 0,
            translateY: s.gapY,
            width: s.width,
            height: s.height,
            groupWidth: (node.measure.width * s.width) + ((node.measure.width - 1) * s.gapX),
            groupHeight: (node.measure.height * s.height) + ((node.measure.height - 1) * s.gapY),
        };
        if (node.measure.depth == 1) {
            layout.translateX = ((prev.svgWidth ?? 0) - layout.groupWidth) / 2;
            layout.translateY = ((prev.top ?? 0) * (s.height + s.gapY));
        }
        else if (node.measure.depth > 1) {
            layout.translateX = ((prev.left ?? 0) * (s.width + s.gapX));
            layout.translateY = (s.height + s.gapY);
        }
        layout.centering = ((layout.groupWidth / 2) - (s.width / 2));
        layout.absoluteX = (prev.absoluteX ?? 0) + layout.translateX;
        layout.absoluteY = (prev.absoluteY ?? 0) + layout.translateY;
        if (node.employees?.length > 0) {
            let p = { top: 0, left: 0 };
            for (let e of node.employees) {
                r_layout(e, s, {
                    ...prev,
                    left: (node.measure.depth > 0 ? p.left : 0),
                    top: (node.measure.depth == 0 ? p.top : 0),
                    absoluteX: layout.absoluteX,
                    absoluteY: layout.absoluteY
                });
                p.left += e.measure.width;
                p.top += e.measure.height;
            }
        }
        node.layout = layout;
        return node;
    };
    // Determine whether a press hits a node and return its index.
    const r_press = (node, x, y, depth) => {
        if ((depth > 0) &&
            (x > node.layout.absoluteX + node.layout.centering) &&
            (x < node.layout.absoluteX + node.layout.centering + node.layout.width) &&
            (y > node.layout.absoluteY) &&
            (y < node.layout.absoluteY + node.layout.height + 20)) // Extra height for A of B text.
         {
            return node.globalIndex;
        }
        else if (node.employees?.length > 0) {
            for (let e of node.employees) {
                let r = r_press(e, x, y, (depth + 1));
                if (r)
                    return r;
            }
        }
        return null;
    };
    react_1.default.useEffect(() => {
        let newVisible = [];
        let newAlways = [];
        if (props.data?.employees?.length > 0) {
            // Show root employees.
            for (let e of props.data.employees) {
                if (e.employees?.length > 0) {
                    newVisible.push(e.id);
                    newAlways.push(e.id);
                }
            }
            // Show employees on path to you.
            let traverse = props.data.employees;
            for (let i of props.data.pathToYou) {
                if (!newVisible.includes(traverse[i].id)) {
                    newVisible.push(traverse[i].id);
                    newAlways.push(traverse[i].id);
                }
                traverse = traverse[i].employees;
            }
            // Show your managed employees.
            if (traverse?.length > 0) {
                for (let c of traverse) {
                    if (!newVisible.includes(c.id)) {
                        newVisible.push(c.id);
                    }
                }
            }
            // For total of employees not connected to chart.
            setStandalone(props.data?.employees?.filter(e => (e.employees ?? []).length == 0));
        }
        setVisible(newVisible);
        setAlways(newAlways);
    }, [props.data]);
    react_1.default.useEffect(() => {
        if (!(visible?.length > 0 && viewSize.set))
            return;
        props.onPhotos?.(visible);
        let prepared = r_filter(props.data, visible);
        prepared = r_measure(prepared, 0);
        let sized = { width: 0, height: 0 };
        for (let e of prepared.employees) {
            sized.height += (e.measure.height * settings.height) + (e.measure.height * settings.gapY);
        }
        sized.width = (prepared.measure.widest * settings.width) + ((prepared.measure.widest + 1) * settings.gapX);
        sized.height += settings.gapY;
        if (standalone?.length > 0)
            sized.height += settings.gapY + 68;
        sized.width = Math.max(viewSize.width, sized.width);
        sized.height = Math.max(viewSize.height, sized.height);
        prepared = r_layout(prepared, settings, { svgWidth: sized.width });
        if (latestY.current === 0) {
            // Translate for initial position.
            latestY.current = 0.001 + ((sized.height - viewSize.height) / 2);
            translateY.setValue(latestY.current);
        }
        else if (sized.height != size.height && react_native_1.Platform.OS == 'web') {
            // Translate to stop expand or collapse from moving view.
            let d = 0;
            if (sized.height > size.height)
                d = 1;
            if (sized.height < size.height)
                d = -1;
            latestY.current += d * ((settings.height + settings.gapY) / 2);
            translateY.setValue(latestY.current);
        }
        setSize(sized);
        setData(prepared);
    }, [visible, viewSize]);
    react_1.default.useLayoutEffect(() => {
        if (viewSize.set)
            return;
        viewRef.current?.measure((x, y, w, h, px, py) => {
            setViewSize({ width: w, height: h, set: true });
        });
    }, []);
    const onExpand = (index) => {
        let employees = props.data.employees;
        for (let i of index) {
            employees = employees[i].employees;
        }
        if (employees?.length > 0) {
            let show = [];
            let hide = [];
            for (let e of employees) {
                if (!always.includes(e.id))
                    hide = [...hide, e.id];
                if (!visible.includes(e.id))
                    show = [...show, e.id];
            }
            if (show.length > 0) {
                setVisible([...visible, ...show]);
            }
            else {
                setVisible(visible.filter(id => !hide.includes(id)));
            }
        }
    };
    const pinch = react_native_gesture_handler_1.Gesture.Pinch()
        .onStart(() => {
        startScale.current = latestScale.current;
    })
        .onUpdate((e) => {
        if (e.numberOfPointers != 2)
            return;
        latestScale.current = startScale.current * e.scale;
        scale.setValue(latestScale.current);
    })
        .runOnJS(true);
    const pan = react_native_gesture_handler_1.Gesture.Pan()
        .minDistance(10)
        .onStart(() => {
        startX.current = latestX.current;
        startY.current = latestY.current;
    })
        .onUpdate((e) => {
        latestX.current = startX.current + (e.translationX * (1 / latestScale.current));
        latestY.current = startY.current + (e.translationY * (1 / latestScale.current));
        translateX.setValue(latestX.current);
        translateY.setValue(latestY.current);
    })
        .runOnJS(true);
    const tap = react_native_gesture_handler_1.Gesture.Tap()
        .onEnd((e) => {
        let centerX = (viewSize.width / 2);
        let centerY = (viewSize.height / 2);
        let offsetX = (size.width / 2) - centerX;
        let offsetY = (size.height / 2) - centerY;
        let tapX = ((e.x - centerX) * (1 / latestScale.current)) + centerX + offsetX - latestX.current;
        let tapY = ((e.y - centerY) * (1 / latestScale.current)) + centerY + offsetY - latestY.current;
        let r = r_press(data, tapX, tapY, 0);
        if (r)
            onExpand(r);
    })
        .runOnJS(true);
    const composed = react_native_gesture_handler_1.Gesture.Race(react_native_gesture_handler_1.Gesture.Simultaneous(pan, pinch), tap);
    const animatedStyle = react_1.default.useMemo(() => ({
        transformOrigin: 'center',
        transform: [
            { scale },
            { translateX },
            { translateY },
        ]
    }), [scale, translateX, translateY]);
    react_1.default.useEffect(() => {
        if (react_native_1.Platform.OS != 'web')
            return;
        viewRef.current.addEventListener('wheel', function (event) {
            let rate = (Math.abs(event.deltaY) > 10 ? 1.1 : 1.01);
            let factor = (event.deltaY < 0 ? rate : 1 / rate);
            latestScale.current = latestScale.current * factor;
            scale.setValue(latestScale.current);
        });
        // @ts-ignore
        global?.window?.addEventListener('resize', function (event) {
            viewRef.current?.measure((x, y, w, h, px, py) => {
                setViewSize({ width: w, height: h, set: true });
            });
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureHandlerRootView, { children: (0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureDetector, { gesture: composed, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { ref: viewRef, style: {
                    flex: 1, overflow: 'hidden', flexDirection: 'row',
                    alignItems: 'center', justifyContent: 'center'
                }, children: (0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: [animatedStyle], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            width: size.width,
                            height: size.height
                        }, children: [data != null &&
                                (0, jsx_runtime_1.jsx)(ChartViewNode, { settings: settings, index: [], data: data, photos: props.photos, left: 0, top: 0, onExpand: onExpand }, "node-root"), standalone?.length > 0 &&
                                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        position: 'absolute', padding: settings.padding,
                                        left: ((size.width / 2) - (settings.width / 2)),
                                        top: (size.height - settings.gapY - 68),
                                        width: settings.width,
                                        height: 68,
                                        backgroundColor: THEME.CardBackground,
                                        borderColor: THEME.Gray,
                                        borderWidth: 1,
                                        borderRadius: 4,
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: { flex: 3, fontSize: 16, textAlign: 'center', color: THEME.Text }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontWeight: '500' }, children: standalone?.length }), " ", t('company:text.orgChartNotShown')] }) })] }) }) }) }) }));
};
const OrgChartContent = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { t } = (0, react_i18next_1.useTranslation)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [data, setData] = react_1.default.useState(null);
    const [photos, setPhotos] = react_1.default.useState({});
    const [view, setView] = react_1.default.useState('chart');
    const [viewingName, setViewingName] = react_1.default.useState('');
    const [settings] = react_1.default.useState(() => {
        let s = userContext.client?.features?.find((feature) => feature.name === 'org-chart');
        return {
            showEmail: userContext.isAdmin ? true : (s?.showEmail ?? false),
            showPhone: userContext.isAdmin ? true : (s?.showPhone ?? false),
        };
    });
    const r_index = (node, index) => {
        node.globalIndex = index;
        if (node.employees?.length > 0) {
            let count = 0;
            for (let e of node.employees) {
                r_index(e, [...index, count]);
                count += 1;
            }
        }
        return node;
    };
    const onPhotos = react_1.default.useCallback((ids) => {
        let promises = [];
        let need = ids.filter((v) => !(v in photos));
        for (let id of need) {
            let i = id;
            promises.push((0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => OrgChart_1.default.getPhoto(token, i))).catch(() => ({ id: i, photo: null })));
        }
        if (promises?.length > 0) {
            Promise.all(promises).then((responses) => {
                let p = { ...photos };
                for (let r of responses) {
                    if (r?.id) {
                        p[r.id] = r.photo;
                    }
                }
                setPhotos(p);
            });
        }
    }, [photos]);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => OrgChart_1.default.getList(token, props.viewingEmployee))).then(data => {
            data = r_index(data, []);
            setData(data);
            if (props.viewingEmployee) {
                let name = '';
                let traverse = data.employees;
                for (let i of data.pathToYou) {
                    name = traverse[i].displayName;
                    traverse = traverse[i].employees;
                }
                setViewingName(name);
            }
            setStatus('done');
        }).catch(e => {
            setStatus('error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (status == 'loading' || status == 'error')
                    &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }, children: (0, jsx_runtime_1.jsx)(Loading_1.default, { loading: status == 'loading', error: status == 'error' }) })
                    ||
                        (view == 'list') && (0, jsx_runtime_1.jsx)(ListView, { settings: settings, data: data })
                    ||
                        (view == 'chart') && (0, jsx_runtime_1.jsx)(ChartView, { settings: settings, data: data, photos: photos, onPhotos: onPhotos }) }), (props.showViewSelect ?? true) &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                        position: 'absolute', top: 0, left: 0,
                        paddingVertical: 6, paddingHorizontal: 12,
                        flexDirection: 'row', gap: 6
                    }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => setView((view == 'list') ? 'chart' : 'list'), style: {
                            backgroundColor: THEME.CardBackground,
                            borderColor: THEME.Gray, borderWidth: 1, borderRadius: 4,
                            flexDirection: 'row', gap: 2,
                            // @ts-ignore
                            userSelect: 'none'
                        }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                    backgroundColor: (view == 'list') ? THEME.CardBackground : THEME.Primary,
                                    borderColor: THEME.CardBackground, borderWidth: 2, borderRadius: 5,
                                    paddingVertical: 6, paddingHorizontal: 10,
                                    flexDirection: 'row', gap: 6, alignItems: 'center'
                                }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.ChartDiagram, size: 18, color: (view == 'list') ? THEME.Text : THEME.CardBackground, style: { outlineWidth: 0 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                            fontSize: 16, fontWeight: '400',
                                            color: (view == 'list') ? THEME.Text : THEME.CardBackground
                                        }, children: t('common:labels.chart') })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                    backgroundColor: (view == 'list') ? THEME.Primary : THEME.CardBackground,
                                    borderColor: THEME.CardBackground, borderWidth: 2, borderRadius: 5,
                                    paddingVertical: 6, paddingHorizontal: 10,
                                    flexDirection: 'row', gap: 6, alignItems: 'center'
                                }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.ListTree, size: 18, color: (view == 'list') ? THEME.CardBackground : THEME.Text, style: { outlineWidth: 0 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                            fontSize: 16, fontWeight: '400',
                                            color: (view == 'list') ? THEME.CardBackground : THEME.Text
                                        }, children: t('common:labels.list') })] })] }) }), (props.showViewingEmployee && viewingName) &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                        position: 'absolute', top: 0, left: 0,
                        paddingVertical: 6, paddingHorizontal: 12,
                        flexDirection: 'row', gap: 6
                    }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                            backgroundColor: THEME.CardBackground,
                            borderColor: THEME.Gray, borderWidth: 1, borderRadius: 4,
                            paddingVertical: 6, paddingHorizontal: 10,
                        }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { children: ["Viewing ", viewingName] }) }) })] }));
};
function OrgChart(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size, tenPercentOfScreen } = (0, ResponsiveContext_1.useResponsiveContext)();
    let wrappedView = true;
    let state = props.navigation.getState();
    if (state) {
        wrappedView = !!!state.routeNames?.includes('Company');
    }
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: (wrappedView ? THEME.ScreenBackground : THEME.CardBackground),
            paddingHorizontal: (wrappedView ? (size != 'sm' ? tenPercentOfScreen : 0) : 0)
        }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                backgroundColor: THEME.CardBackground,
                borderColor: THEME.CardBorder,
                borderRadius: (wrappedView ? (size != 'sm' ? 4 : 0) : 0),
                borderWidth: (wrappedView ? 1 : 0),
                margin: (wrappedView ? (size != 'sm' ? 8 : 0) : 0),
                padding: (size != 'sm' ? 6 : 0),
                flex: 1
            }, children: (0, jsx_runtime_1.jsx)(OrgChartContent, { showViewSelect: wrappedView, showViewingEmployee: !wrappedView, viewingEmployee: props.route?.params?.employeeId }) }) }));
}
